export default (htmlWrap) => {
  return {
    methods: {
      print() {
        this.$nextTick(() => {
          this.$htmlToPaper(htmlWrap)
        })
      }
    }
  }
}